export default __webpack_public_path__ + "static/media/letter-y.c359276f.png";